import axios from "axios";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

export default function CelebritiesComponent({ src }) {
  const [isButton, setIsButton] = useState(false);
  const [socialMedia, setSocialMedia] = React.useState([]);

  // const [loading, setLoading] = React.useState(false);
  const [config, setConfig] = React.useState([]);

  const getConfigDetails = async () => {
    try {
      const response = await axios.get("/api/config");
      setConfig(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getConfigDetails();
  }, []);

  React.useEffect(() => {
    if (config.length > 0) {
      setSocialMedia(config[0]?.socialMedia);
    }
  }, [config]);
  const containerStyle = {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    aspectRatio: "3 / 4",
    borderRadius: "4px",
  };
  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",

    filter: isButton ? "blur(5px)" : "none",
  };
  const buttonContainerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1,
  };
  const buttonStyle = {
    padding: "8px",
    // background: "#285979",
    background: "transparent",
    border: "2px solid white ",
    color: "#fff",

    // border: "none",
    cursor: "pointer",
    borderRadius: "10px",
    fontSize: "0.9rem",
    fontWeight: "bold",
  };

  const handleImageHover = () => {
    setIsButton(true);
  };

  const handleImageLeave = () => {
    setIsButton(false);
  };

  return (
    <div
      className="image-container"
      style={containerStyle}
      onMouseEnter={handleImageHover}
      onMouseLeave={handleImageLeave}
    >
      <img className="d-block" src={src} alt={`Bride `} style={imageStyle} />
      {isButton && (
        <div style={buttonContainerStyle}>
          <button
            onClick={() => {
              const number = "919100006969";
              const message =
                "Hi, I would like to shop this celebrity look with you.";
              const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(
                navigator.userAgent
              );
              const url = isMobile
                ? `https://wa.me/${number}?text=${encodeURIComponent(message)}`
                : `https://web.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(
                    message
                  )}`;
              window.open(url, "_blank");
            }}
            className="custom-button"
          >
            {`Shop this look with us`.toUpperCase()}
          </button>
        </div>
      )}
    </div>
  );
}
